import React from 'react';
import $ from "jquery";
import axios from "axios";
import {
    getFromLocalStorage,
    sendToLocalStorage,
    strstr,
    isSimpleNavigation,
    removeNestedNullUndefined
} from './Utilities';

class ReportsNavigation extends React.Component {
    
    constructor(props){
        super(props);
        
        this.state = {
            steps: {},
            data: {},
            dataReady: false,
            reportType: props.reportType,
            tabs: props.tabs
        };
    }

    componentDidMount(){   
       this.setState({
            dataReady: false
        });     
        this.getData();
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if(Object.keys(this.state.data).length > 0 && !this.state.dataReady) {
            this.setState({
                dataReady: true
            });
            
            this.setSteps();
        }
    }

    getData(){
        var data = getFromLocalStorage("report_data");
        if(!data) data = {};
        this.formatData(data);
    }

    formatData(data){
        if(this.state.reportType){
            if(data.ReportType !== this.state.reportType)
                data.ReportType = this.state.reportType;//ensure saved report type is the same as state
        } else {
            this.setState({
                reportType: data.ReportType //otherwise if no reportType in state use the one from data
            });
        }

        data = sendToLocalStorage("report_data", data);
        this.setState({
            data: data
        });
    }

    getSteps(){
        var steps = [
            {Name: 'ReportType', Label: 'Choose report type'},
            {Name: 'ChooseBrands', Label: 'Choose brands'},
            {Name: 'ChooseActivities', Label: 'Choose activities'},
            {Name: 'DateRange', Label: 'Pick dates'},
            {Name: 'OtherCriteria', Label: 'Other criteria'}
        ];

        //add active inactive state from parent
        var tabs = this.state.tabs;
        if(tabs){
            $(steps).filter(function(index, step){
                step.Status = tabs[step.Name+"Tab"].status;
            });
        }
        return steps;
    }

    setSteps(){
        // console.log("generating navigation steps");

        var steps = this.getSteps();

        if (this.state.reportType) {
            
            const reportType = this.state.reportType.toLowerCase();

            if (isSimpleNavigation(reportType)) {
                delete(steps[1]); //brands
                delete(steps[2]); //activities
             }       
        } 
        this.setState({
            // steps: removeNestedNullUndefined(steps)
            steps: steps
        });
    }

    onClick(step){
        if(strstr(window.location.pathname, "results"))
            return window.location.href = "/dashboard/reports#"+step;
        this.props.handleNavigation(step); //send to parent
    }

    render() {
        var count = 0;
        var key = this.state.dataReady;

        if(Object.keys(this.state.steps).length > 0){
            return (
                <React.Fragment>
                    <ul id="ReportFormNavigation" className="nav nav-pills nav-justified form-wizard-header position-relative mb-3" key={key}>                   
                        {this.state.steps.map((step,index) => {
                            {count++}
                            // {console.log(step)}
                            return(
                                <li className={"nav-item "+step.Status} key={index}>
                                    <a href={"#"+step.Name} data-bs-toggle="tab" data-toggle="tab" onClick={() => this.onClick(step.Name)}
                                        className={"nav-link "+step.Name+" "+step.Status}>
                                        <span className="number">{count}</span>
                                        <span className="d-none d-sm-block text">{step.Label}</span>
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </React.Fragment>
            );
        } else {
            return(
                <React.Fragment>
                    <div className="row form-wizard-header">
                        <div className="col-md-4"></div>
                        <div className="col-md-4 react-loading horizontal navigation-loader"></div>
                        <div className="col-md-4"></div>
                    </div>
                </React.Fragment>
            );
        }
    }
}

export default ReportsNavigation;
